import Vue from 'vue'
import Router from 'vue-router'
import M404 from '../views/404.vue'

// 注册模块
import Login from '@/views/layout/login/index.vue'
import ForgotPwd from '@/views/layout/login/forgotPwd.vue'
import SignIn from '@/views/layout/login/signIn.vue'

//首页模块
import Home from '@/views/layout/home/index.vue'
import Location from '@/views/layout/home/location.vue'
import Search from '@/views/layout/home/Search.vue'
import LookingSite from '@/views/layout/home/lookingSite.vue'
import SubmitLookingSite from '@/views/layout/home/submitLookingSite.vue'
import SiteDetail from '@/views/layout/home/siteDetail'
import SiteLease from '@/views/layout/home/siteLease.vue'
import SiteSubscribe from '@/views/layout/home/siteSubscribe.vue'
import PlaySuccess from '@/views/layout/home/playSuccess.vue'

//分销模块
import Distribution from '@/views/layout/distribution/index.vue'
import Withdraw from '@/views/layout/distribution/withdraw.vue'
import WithdrawDetail from '@/views/layout/distribution/withdrawDetail.vue'
import Commission from '@/views/layout/distribution/commission.vue'
import PayOrder from '@/views/layout/distribution/payOrder.vue'
import MyCustomer from '@/views/layout/distribution/myCustomer.vue'
import CodeShare from '@/views/layout/distribution/codeShare.vue'

//订单模块
import Order from '@/views/layout/order/index.vue'
import ContractFinish from '@/views/layout/order/contractFinish.vue'
import CancelOrder from '@/views/layout/order/cancelOrder.vue'
import CancelRefund from '@/views/layout/order/cancelRefund.vue'
import ContractBrowse from '@/views/layout/order/contractBrowse.vue'
import Evaluate from '@/views/layout/order/evaluate.vue'
import EvaluateFinish from '@/views/layout/order/evaluateFinish.vue'
import ContractData from '@/views/layout/order/contractData.vue'
import OrderDetail from '@/views/layout/order/orderDetail.vue'
import OrderEdit from '@/views/layout/order/OrderEdit.vue'
import AppointmentData from '@/views/layout/order/appointmentData.vue'

//我的模块
import Personal from '@/views/layout/personal/index.vue'
import Coupon from '@/views/layout/personal/coupon.vue'
import GetCouponCenter from '@/views/layout/personal/getCouponCenter.vue'
import SuperMembers from '@/views/layout/personal/superMembers.vue'
import ContractManagement from '@/views/layout/personal/contractManagement.vue'
import ApplicationForSite from '@/views/layout/personal/applicationForSite.vue'
import MaterialProgress from '@/views/layout/personal/materialProgress.vue'
import Setting from '@/views/layout/personal/setting.vue'
import Appointment from '@/views/layout/personal/appointment.vue'
import CollectList from '@/views/layout/personal/collectList.vue'
import UserAgreement from '@/views/layout/personal/userAgreement.vue'
import PlaceAgreement from '@/views/layout/personal/placeAgreement.vue'

//场地方模块
import Place from '@/views/layout/place/index.vue'
import PlaceManagement from '@/views/layout/place/placeManagement.vue'
import PlaceIssue from '@/views/layout/place/placeIssue.vue'
import PlaceEdit from '@/views/layout/place/placeEdit.vue'
import EditPlaceSuccess from '@/views/layout/place/editPlaceSuccess.vue'
import AppointmentManagement from '@/views/layout/place/appointmentManagement.vue'
import ClientManagement from '@/views/layout/place/clientManagement.vue'
import ClientEdit from '@/views/layout/place/clientEdit.vue'
import ClientDetail from '@/views/layout/place/clientDetail.vue'
import PushContract from '@/views/layout/place/pushContract.vue'
import FinancialFlow from '@/views/layout/place/financialFlow.vue'
import FlowDetail from '@/views/layout/place/flowDetail.vue'
import PlaceSetting from '@/views/layout/place/placeSetting.vue'
import StaffManagement from '@/views/layout/place/staffManagement.vue'
import StaffAdd from '@/views/layout/place/staffAdd.vue'
import StaffEdit from '@/views/layout/place/staffEdit.vue'
import OrderList from '@/views/layout/place/orderList.vue'
import PlaceWithdraw from '@/views/layout/place/withdraw.vue'
import PlaceWithdrawDetail from '@/views/layout/place/withdrawDetail.vue'


//将这段代码添加到你的index.js中即可
const originalPush = Router.prototype.push
    // 修改原型对象中的push方法
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

const routes = [{
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: '首页',
            needLogin: false
        }
    }, {
        path: '/home/siteDetail',
        name: 'SiteDetail',
        component: SiteDetail,
        meta: {
            title: '写字楼详情',
            needLogin: false
        }
    }, {
        path: '/home/siteLease',
        name: 'SiteLease',
        component: SiteLease,
        meta: {
            title: '立即租赁',
            needLogin: true
        }
    }, {
        path: '/home/siteSubscribe',
        name: 'SiteSubscribe',
        component: SiteSubscribe,
        meta: {
            title: '立即预约',
            needLogin: true
        }
    }, {
        path: '/home/location',
        name: 'Location',
        component: Location,
        meta: {
            title: '选择城市',
            needLogin: false
        }
    }, {
        path: '/home/search',
        name: 'Search',
        component: Search,
        meta: {
            title: '搜索',
            needLogin: false
        }
    }, {
        path: '/home/lookingSite',
        name: 'LookingSite',
        component: LookingSite,
        meta: {
            title: '帮我找场地',
            needLogin: true
        }
    },
    {
        path: '/home/playSuccess',
        name: 'PlaySuccess',
        component: PlaySuccess,
        meta: {
            title: '支付成功',
            needLogin: true
        }
    },
    {
        path: '/home/submitLookingSite',
        name: 'SubmitLookingSite',
        component: SubmitLookingSite,
        meta: {
            title: '提交帮我找场地',
            needLogin: true
        }
    }, {
        path: '/distribution/index',
        name: 'Distribution',
        meta: {
            title: '分销',
            roles: ['admin'] // 需要有admin角色才能访问
        },
        component: Distribution,
    }, {
        path: '/distribution/withdraw',
        name: 'Withdraw',
        meta: {
            title: '申请提现',
            roles: ['admin'] // 需要有admin角色才能访问
        },
        component: Withdraw,
    }, {
        path: '/distribution/commission',
        name: 'Commission',
        meta: {
            title: '分销佣金',
            roles: ['admin'] // 需要有admin角色才能访问
        },
        component: Commission,
    }, {
        path: '/distribution/payOrder',
        name: 'PayOrder',
        meta: {
            title: '支付订单',
            roles: ['admin'] // 需要有admin角色才能访问
        },
        component: PayOrder,
    }, {
        path: '/distribution/myCustomer',
        name: 'MyCustomer',
        meta: {
            title: '我的顾客',
            roles: ['admin'] // 需要有admin角色才能访问
        },
        component: MyCustomer,
    }, {
        path: '/distribution/withdrawDetail',
        name: 'WithdrawDetail',
        meta: {
            title: '提现明细',
        },
        component: WithdrawDetail,
    }, {
        path: '/distribution/codeShare',
        name: 'CodeShare',
        meta: {
            title: '二维码分享',
        },
        component: CodeShare,
    }, {
        path: '/order/index',
        name: 'Order',
        meta: {
            title: '订单',
            needLogin: true
        },
        component: Order
    }, {
        path: '/order/contractData',
        name: 'ContractData',
        meta: {
            title: '资料补全',
            needLogin: true
        },
        component: ContractData
    }, {
        path: '/order/contractBrowse',
        name: 'ContractBrowse',
        meta: {
            title: '合同浏览',
            needLogin: true
        },
        component: ContractBrowse
    },
    {
        path: '/order/contractFinish',
        name: 'ContractFinish',
        meta: {
            title: '提交成功',
            needLogin: true
        },
        component: ContractFinish
    },
    {
        path: '/order/evaluate',
        name: 'Evaluate',
        meta: {
            title: '评价',
            needLogin: true
        },
        component: Evaluate
    },
    {
        path: '/order/evaluateFinish',
        name: 'EvaluateFinish',
        meta: {
            title: '评价成功',
            needLogin: true
        },
        component: EvaluateFinish
    },

    {
        path: '/order/orderDetail',
        name: 'OrderDetail',
        meta: {
            title: '订单详情',
            needLogin: true //
        },
        component: OrderDetail
    },

    {
        path: '/order/OrderEdit',
        name: 'OrderEdit',
        meta: {
            title: '订单编辑',
            needLogin: true //
        },
        component: OrderEdit
    },

    {
        path: '/order/appointmentData',
        name: 'AppointmentData',
        meta: {
            title: '预约上门时间',
            needLogin: true
        },
        component: AppointmentData
    }, {
        path: '/order/cancelOrder',
        name: 'CancelOrder',
        meta: {
            title: '取消订单',
            needLogin: true
        },
        component: CancelOrder
    }, {
        path: '/order/cancelRefund',
        name: 'CancelRefund',
        meta: {
            title: '退款申请',
            needLogin: true
        },
        component: CancelRefund
    },
    {
        path: '/personal/index',
        name: 'Personal',
        meta: {
            title: '我的',
            needLogin: true
        },
        component: Personal
    }, {
        path: '/personal/coupon',
        name: 'Coupon',
        meta: {
            title: '优惠券',
            needLogin: true
        },
        component: Coupon
    }, {
        path: '/personal/getCouponCenter',
        name: 'GetCouponCenter',
        meta: {
            title: '优惠券中心',
            needLogin: true
        },
        component: GetCouponCenter
    }, {
        path: '/personal/superMembers',
        name: 'SuperMembers',
        meta: {
            title: '申请成为超级会员',
            needLogin: true
        },
        component: SuperMembers
    }, {
        path: '/personal/applicationForSite',
        name: 'ApplicationForSite',
        meta: {
            title: '申请成为场地方',
            needLogin: true
        },
        component: ApplicationForSite
    },
    {
        path: '/personal/userAgreement',
        name: 'UserAgreement',
        meta: {
            title: '用户协议',
            needLogin: false
        },
        component: UserAgreement
    }, {
        path: '/personal/placeAgreement',
        name: 'PlaceAgreement',
        meta: {
            title: '场地方入驻协议',
            needLogin: false
        },
        component: PlaceAgreement
    },
    {
        path: '/personal/materialProgress',
        name: 'MaterialProgress',
        meta: {
            title: '资料审核',
            needLogin: true
        },
        component: MaterialProgress
    },
    {
        path: '/personal/contractManagement',
        name: 'ContractManagement',
        meta: {
            title: '合同管理',
            needLogin: true
        },
        component: ContractManagement
    },
    {
        path: '/personal/setting',
        name: 'Setting',
        meta: {
            title: '账号设置',
            needLogin: true
        },
        component: Setting
    },
    {
        path: '/personal/appointment',
        name: 'Appointment',
        meta: {
            title: '我的预约',
            needLogin: true
        },
        component: Appointment
    },

    {
        path: '/personal/collectList',
        name: 'CollectList',
        meta: {
            title: '收藏列表',
            needLogin: true
        },
        component: CollectList
    },
    {
        path: '/place/index',
        name: 'Place',
        meta: {
            title: '场地方',
            needLogin: true
        },
        component: Place
    }, {
        path: '/place/placeManagement',
        name: 'PlaceManagement',
        meta: {
            title: '卡位管理',
            needLogin: true
        },
        component: PlaceManagement
    }, {
        path: '/place/placeIssue',
        name: 'PlaceIssue',
        meta: {
            title: '发布场地',
            needLogin: true
        },
        component: PlaceIssue
    }, {
        path: '/place/placeEdit',
        name: 'PlaceEdit',
        meta: {
            title: '编辑场地',
            needLogin: true
        },
        component: PlaceEdit
    }, {
        path: '/place/editPlaceSuccess',
        name: 'EditPlaceSuccess',
        meta: {
            title: '编辑成功',
            needLogin: true
        },
        component: EditPlaceSuccess
    }, {
        path: '/place/appointmentManagement',
        name: 'AppointmentManagement',
        meta: {
            title: '预约管理',
            needLogin: true
        },
        component: AppointmentManagement
    },
    {
        path: '/place/clientManagement',
        name: 'ClientManagement',
        meta: {
            title: '客户管理',
            needLogin: true
        },
        component: ClientManagement
    },
    {
        path: '/place/clientEdit',
        name: 'ClientEdit',
        meta: {
            title: '客户编辑',
            needLogin: true
        },
        component: ClientEdit
    }, {
        path: '/place/clientDetail',
        name: 'ClientDetail',
        meta: {
            title: '客户详情',
            needLogin: true
        },
        component: ClientDetail
    },
    {
        path: '/place/orderList',
        name: 'OrderList',
        meta: {
            title: '订单管理',
            needLogin: true
        },
        component: OrderList
    },
    {
        path: '/place/pushContract',
        name: 'PushContract',
        meta: {
            title: '上传合同',
            needLogin: true
        },
        component: PushContract
    }, {
        path: '/place/financialFlow',
        name: 'FinancialFlow',
        meta: {
            title: '财务流水',
            needLogin: true
        },
        component: FinancialFlow
    }, {
        path: '/place/withdraw',
        name: 'PlaceWithdraw',
        meta: {
            title: '申请提现',
        },
        component: PlaceWithdraw,
    },
    {
        path: '/place/withdrawDetail',
        name: 'PlaceWithdrawDetail',
        meta: {
            title: '提现明细',
        },
        component: PlaceWithdrawDetail,
    }, {
        path: '/place/flowDetail',
        name: 'FlowDetail',
        meta: {
            title: '流水详情',
            needLogin: true
        },
        component: FlowDetail
    }, {
        path: '/place/staffManagement',
        name: 'StaffManagement',
        meta: {
            title: '员工列表',
            needLogin: true
        },
        component: StaffManagement
    }, {
        path: '/place/staffAdd',
        name: 'StaffAdd',
        meta: {
            title: '添加员工',
            needLogin: true
        },
        component: StaffAdd
    }, {
        path: '/place/staffEdit',
        name: 'StaffEdit',
        meta: {
            title: '编辑员工',
            needLogin: true
        },
        component: StaffEdit
    },
    {
        path: '/place/placeSetting',
        name: 'PlaceSetting',
        meta: {
            title: '账号设置',
            needLogin: true
        },
        component: PlaceSetting
    },
    {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
            title: '登录',
        }
    },
    {
        path: '/login/forgotPwd',
        name: 'ForgotPwd',
        component: ForgotPwd,
        meta: {
            title: '忘记密码',
            needLogin: false
        }
    },
    {
        path: '/login/signIn',
        name: 'SignIn',
        component: SignIn,
        meta: {
            title: '新用户注册',
            needLogin: false
        }
    },
    {
        path: '/:pathMatch(.*)*',
        meta: {
            title: '404',
            needLogin: false
        },
        component: M404
    },
]

const router = new Router({
    mode: process.env.ROUTER_MODEL,
    base: process.env.BASE_URL,
    routes
})

import storage from "@/utils/storage";

//路由守卫-前置处理器/拦截器
router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.title) {
        document.title = to.meta.title;
    }
    if (to.path === '/login') {
        next();
    } else {
        //使用路由元数据判断是否需要登录
        if (to.meta && to.meta.needLogin === false) {
            next();
        } else {
            let token = (to.query.access_token) ? "Bearer " + to.query.access_token : "";
            token = token.includes("Bearer Bearer ") ? token.replace("Bearer ",""):token;
            if (token != "") {
                storage.setToken(token); //设置请求头值
                storage.setUserInfo(token); //设置请求头值
            }
            //alert('storage.getToken'+JSON.stringify(storage.getToken())+'token'+token+'storage.setUserInfo'+JSON.stringify(storage.getUserInfo()))
            console.log('storage.getToken'+JSON.stringify(storage.getToken())+'token'+token+'storage.setUserInfo'+JSON.stringify(storage.getUserInfo()))
            if (storage.getToken()) {
                next();
            } else {
                next({
                    path: '/login'
                })
            }

        }
    }

})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js